import axios from "axios";
import router from "../router/index";
import $ from "jquery";
import Vue from "vue";
const days = {
    state: () => ({
        items: [],
        filter: {
            searchTerm: null,
            skip: 0,
            take: 20,
            total: 0,
            page: 1,
        },
        selectedItems: [],
        loading: true,
    }),
    mutations: {
        setDays(state, payload) {
            state.items = payload.items;
            state.filter.total = payload.total;
        },
        setSelectedDays(state, payload) {
            state.selectedItems = payload;
        },
        setDayPage(state, payload) {
            state.filter.page = payload;
        },
        setDayTake(state, payload) {
            state.filter.page = 1;
            state.filter.take = payload;
        },
    },
    actions: {
        async getDays(store) {
            store.state.loading = true;
            await axios
                .post("day/load", {
                    ...store.state.filter,
                    skip: (store.state.filter.page - 1) * store.state.filter.take,
                })
                .then((res) => {
                    store.state.loading = false;
                    return store.commit("setDays", res.data.data);
                });
        },
        async toggleDay(store, payload) {
            var res = await axios.post("day/toggleisactive", {
                id: store.state.items[payload.index].id,
            });
            return res.data;
        },
        async deleteDay(store, payload) {
            await axios
                .post("day/delete", {
                    id: store.state.items[payload.index].id,
                })
                .then((res) => {
                    if (res.data.alert.hasError) {
                        payload.context.$message.error(res.data.alert.message);
                    } else {
                        store.state.items.splice(payload.index, 1);
                        payload.context.$message.success(res.data.alert.message);
                        if (store.state.items.length == 0 && store.state.filter.page != 1) {
                            this.commit("setDayPage", store.state.filter.page - 1);
                        }
                        store.state.filter.total = store.state.filter.total - 1;
                    }
                });
        },
    },
    getters: {},
};
export default days;


// WEBPACK FOOTER //
// ./src/store/days.js